<!--
  Indicador discreto de operacao em segundo plano (port de origin/corrigir-tipos-projeto
  7fd10c0f). Circulo no canto inferior direito, sem bloquear a tela: enquanto
  `executandoDiscretoSpinning` mostra o logo se desenhando; quando a operacao termina
  troca pelo icone de sucesso (check) ou de erro (X) e some depois do atraso do store.

  Dois desvios do original, ambos de intencao e ambos medidos em teste:
    - o `v-if` do logo era `spinning || executandoDiscreto`, sempre verdadeiro com o
      circulo visivel, entao o icone de resultado NUNCA aparecia. Vale so `spinning`.
    - o roxo vinha em hex colado; ADR-0002 manda `var(--gali-cor-primaria)`.
-->
<template>
  <Transition name="discreto">
    <div v-if="layout.executandoDiscreto" class="loading-discreto" role="status">
      <svg v-if="layout.executandoDiscretoSpinning" viewBox="0 0 83.97 79.43" class="logo-trace">
        <path class="fill-path" :d="CAMINHO_LOGO" />
        <path pathLength="1" class="trace-path" :d="CAMINHO_LOGO" />
      </svg>
      <svg
        v-else
        viewBox="0 0 24 24"
        class="icon-trace"
        :class="layout.executandoDiscretoResponse ? 'icon-success' : 'icon-error'"
        :data-resultado="layout.executandoDiscretoResponse ? 'sucesso' : 'erro'"
      >
        <path
          pathLength="1"
          :d="layout.executandoDiscretoResponse ? CAMINHO_CHECK : CAMINHO_CLOSE"
        />
      </svg>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import layoutStore from "@/store/layout";

const layout = layoutStore();

/** Contorno do logo Gali (83.97 x 79.43) — o mesmo do original. */
const CAMINHO_LOGO =
  "M60.97,0c-13.13,0-23.8,10.74-23.8,23.37s10.08,22.19,22.64,22.19c4.34,0,8.32-1.3,11.72-3.42-.94,7.55-3.63,14.63-9.5,20.06-9.26,8.62-21.11,8.5-33.65,8.62l-19.11,.23c.59-24.2,2.58-36.47,5.16-42.72,4.1-9.79,10.44-15.94,21.58-17.59,1.99-3.07,4.92-7.44,10.55-10.15C31.54,.59,19.11,6.02,11.14,15.94,2.11,27.27,1.17,48.74,0,79.43H31.9c24.28,0,43.04-7.08,48.43-33.64,1.87-9.2,3.51-29.86,3.63-45.79h-23Zm-1.05,37.52c-7.86,0-13.95-6.37-13.95-14.28s6.1-14.28,13.95-14.28,14.19,6.37,14.19,14.28c0,7.91-6.34,14.28-14.19,14.28Z";
/** Check (mdi-check) e X (mdi-close), em viewBox 24x24. */
const CAMINHO_CHECK = "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z";
const CAMINHO_CLOSE =
  "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z";
</script>

<style lang="scss" scoped>
.loading-discreto {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 3000;
  width: 48px;
  height: 48px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-trace {
  width: 30px;
  height: 30px;
}

.icon-trace {
  width: 30px;
  height: 30px;

  path {
    fill: none;
    stroke-width: 1.5;
    stroke-dasharray: 1;
    stroke-dashoffset: 1;
    animation: trace 0.5s ease-out forwards;
  }

  &.icon-success path {
    stroke: rgb(var(--v-theme-success));
  }

  &.icon-error path {
    stroke: rgb(var(--v-theme-error));
  }
}

.fill-path {
  fill: var(--gali-cor-primaria);
  opacity: 0;
  animation: fill-appear 2.6s ease-in-out infinite;
}

.trace-path {
  fill: none;
  stroke: var(--gali-cor-primaria);
  stroke-width: 2;
  stroke-dasharray: 1;
  stroke-dashoffset: 1;
  animation: trace 2.6s ease-in-out infinite;
}

@keyframes fill-appear {
  0% {
    opacity: 0;
  }
  35% {
    opacity: 0;
  }
  65% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  85% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes trace {
  0% {
    stroke-dashoffset: 1;
    opacity: 0;
  }
  5% {
    opacity: 1;
  }
  60% {
    stroke-dashoffset: 0;
    opacity: 1;
  }
  80% {
    stroke-dashoffset: 0;
    opacity: 0;
  }
  81% {
    stroke-dashoffset: 1;
    opacity: 0;
  }
  100% {
    stroke-dashoffset: 1;
    opacity: 0;
  }
}

.discreto-enter-active,
.discreto-leave-active {
  transition:
    opacity 0.25s,
    transform 0.25s;
}

.discreto-enter-from,
.discreto-leave-to {
  opacity: 1;
  transform: scale(0.6);
}
</style>
